/**
 * The `data-focus-key` values the panel uses to put keyboard focus back on the row (or citation link) that
 * opened an article or topic, once that view closes.
 */

export function articleFocusKey(articleId: string): string {
  return `article:${articleId}`;
}

export function topicFocusKey(category: string): string {
  return `topic:${category}`;
}
